import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-forbidden',
    templateUrl: './page-forbidden.component.html',
    styleUrls: ['./page-forbidden.component.css'],
    standalone: false
})
export class PageForbiddenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
